var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Transition } from '@headlessui/react';
import { useParams } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { availableLanguages } from "../../../../shared/languagesList";
import { Translate } from "../../../I18N";










const sidepanelHeader = (closeSidepanelFunction, title) => /*#__PURE__*/
_jsx("div", { className: "flex mb-2 text-gray-500" }, void 0, /*#__PURE__*/
_jsx("h1", { className: "text-base font-bold grow" }, void 0, title), /*#__PURE__*/
_jsx("button", {
  type: "button",
  className: "justify-end",
  "data-testid": "close-sidepanel",
  onClick: closeSidepanelFunction }, void 0, /*#__PURE__*/

_jsx("span", { className: "sr-only" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Close")
), /*#__PURE__*/
_jsx(XMarkIcon, { className: "w-6" })
)
);


// eslint-disable-next-line max-statements
const Sidepanel = ({
  children,
  closeSidepanelFunction,
  isOpen = false,
  title,
  withOverlay,
  size = 'medium'
}) => {var _availableLanguages$f;
  const { lang: languageKey } = useParams();

  let transitionRight = '-translate-x-[500px]';
  let transitionLeft = '-translate-x-[-500px]';
  let width = 'md:w-[500px]';

  switch (size) {
    case 'small':
      transitionRight = '-translate-x-[300px]';
      transitionLeft = '-translate-x-[-300px]';
      width = 'md:w-[300px]';
      break;

    case 'large':
      transitionRight = '-translate-x-[700px]';
      transitionLeft = '-translate-x-[-700px]';
      width = 'md:w-[700px]';
      break;

    default:
      break;
  }

  const isRigthToLeft = (_availableLanguages$f = availableLanguages.find((language) => language.key === languageKey)) === null || _availableLanguages$f === void 0 ? void 0 : _availableLanguages$f.rtl;
  const transition = isRigthToLeft ? transitionRight : transitionLeft;
  const contentClasses = 'flex flex-col h-full overflow-y-auto';

  if (withOverlay) {
    return /*#__PURE__*/(
      _jsx(Transition, { show: isOpen, className: "fixed top-0 left-0 z-10 flex w-full h-full" }, void 0, /*#__PURE__*/
      _jsx(Transition.Child, {
        className: "w-0 transition-opacity duration-200 ease-in bg-gray-900 md:flex-grow",
        enterFrom: "opacity-0",
        enterTo: "opacity-50",
        leaveTo: "opacity-0",
        onClick: closeSidepanelFunction }
      ), /*#__PURE__*/
      _jsx(Transition.Child, {
        as: "aside",
        className: `transition transform duration-200 ease-in bg-white border-l-2 p-4 w-full ${width}`,
        enterFrom: transition,
        enterTo: "translate-x-0",
        leaveTo: transition }, void 0, /*#__PURE__*/

      _jsx("div", { className: contentClasses }, void 0,
      sidepanelHeader(closeSidepanelFunction, title), /*#__PURE__*/
      _jsx("div", { className: "flex-grow" }, void 0, children)
      )
      )
      ));

  }

  return /*#__PURE__*/(
    _jsx(Transition, {
      show: isOpen,
      as: "aside",
      className: `transition transform ease-in duration-200 fixed h-full w-full top-0 right-0
      bg-white border-l-2 p-4 shadow-lg z-10 ${width}`,
      enterFrom: transition,
      enterTo: "translate-x-0",
      leaveTo: transition }, void 0, /*#__PURE__*/

    _jsx("div", { className: contentClasses }, void 0,
    sidepanelHeader(closeSidepanelFunction, title), /*#__PURE__*/
    _jsx("div", { className: "flex-grow" }, void 0, children)
    )
    ));

};


export { Sidepanel };